import { ClubSlug } from '@/fairplayer/domain/club/ClubSlug';
import { Member } from '@/fairplayer/domain/member/Member';
import { InjectionKey } from 'vue';

export const memberRepositoryKey: InjectionKey<MemberRepository> = Symbol();

export interface MemberRepository {
  getForClub(slug: ClubSlug): Promise<Member[]>;
}
